export default {
    STRING_REQUIRED: "Field cannot be empty",
    STRING_TOO_SHORT: "Text is too short",
    STRING_TOO_LONG: "Max characters",
    NON_WHITESPACE_REQUIRED: "Non-whitespace character required",
}
